module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.handler.open()
      }
    }
  }, [_vm._v("\n    Add Account\n  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": function($event) {
        _vm.deleteAll()
      }
    }
  }, [_vm._v("\n    Delete All\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c0f296"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaidLink.vue
// module id = 220
// module chunks = 1